import { render, staticRenderFns } from "./plan-soins-express.html?vue&type=template&id=5fecdea0&scoped=true&external"
import script from "./plan-soins-express.js?vue&type=script&lang=js&external"
export * from "./plan-soins-express.js?vue&type=script&lang=js&external"
import style0 from "./plan-soins-express.scss?vue&type=style&index=0&id=5fecdea0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fecdea0",
  null
  
)

export default component.exports